import { useMutation } from '@tanstack/react-query'
import { api } from '../api/client'
import type { LoginResponse } from '../api/types'
import { useAuthStore } from './authStore'

interface Credentials {
  email: string
  password: string
}

/**
 * Login del panel: no envía bloque `device`, porque solo los empleados
 * vinculan un teléfono. Un empleado que intente entrar acá es rechazado
 * por el propio panel (ver validación de rol más abajo).
 */
export function useLogin() {
  const setSession = useAuthStore((state) => state.setSession)

  return useMutation({
    mutationFn: async (credentials: Credentials): Promise<LoginResponse> => {
      const { data } = await api.post<LoginResponse>('/auth/login', credentials)
      return data
    },
    onSuccess: (data) => {
      setSession(data.access_token, data.user, data.expires_in)
    },
  })
}

export function useLogout() {
  const clear = useAuthStore((state) => state.clear)

  return useMutation({
    mutationFn: async () => {
      // Se intenta invalidar el token en el servidor, pero la sesión local se
      // cierra igual: el usuario no debe quedar atrapado si la red falla.
      try {
        await api.post('/auth/logout')
      } catch {
        /* sesión local igualmente cerrada */
      }
    },
    onSettled: () => clear(),
  })
}
